import { subject as caslSubject } from '@casl/ability';
import type { AnyAbility } from '@casl/ability';

import { MemberPermissionType, ResourceActivityResourceType } from '@/types';

import type { AppAbility, PermissionTuple } from '.';

const workspaceActivityExportRoles = new Set<MemberPermissionType>([
    MemberPermissionType.ADMIN,
    MemberPermissionType.OWNER,
]);

export const resourceActivityExportPermissionMap: Partial<Record<ResourceActivityResourceType, PermissionTuple>> = {
    dashboards: ['update', 'Dashboard'],
    folders: ['update', 'Folder'],
    investments: ['update', 'Investment'],
    lifecycles: ['update', 'Lifecycle'],
    listViews: ['update', 'ListView'],
    lists: ['update', 'List'],
    memos: ['update', 'Memo'],
    pipelines: ['update', 'Pipeline'],
    reportComponents: ['update', 'Report'],
    reports: ['update', 'Report'],
    teams: ['update', 'Team'],
};

interface CanExportResourceActivityOptions {
    ability: AppAbility | AnyAbility;
    authorizationResourceId?: string;
    memberPermission?: MemberPermissionType;
    resourceId: string;
    resourceType: ResourceActivityResourceType;
}

export const canExportResourceActivity = ({
    ability,
    authorizationResourceId,
    memberPermission,
    resourceId,
    resourceType,
}: CanExportResourceActivityOptions) => {
    if (memberPermission && workspaceActivityExportRoles.has(memberPermission)) {
        return true;
    }

    const permission = resourceActivityExportPermissionMap[resourceType];
    const permissionResourceId = resourceType === 'reportComponents' ? authorizationResourceId : resourceId;

    if (!permission || !permissionResourceId) {
        return false;
    }

    return ability.can(permission[0], caslSubject(permission[1], { id: permissionResourceId }));
};
